/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/countries';
import '../verification/verification';
import '../../common/time';
import '../../onboard/activation/common';
import '../../common/currency';
import '../../common/address';
import '../../common/location';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "legalentities": {
        "nested": {
          "model": {
            "nested": {
              "Structure": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "versionToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "sint32",
                    "id": 8,
                    "rule": "optional"
                  },
                  "rootLegalEntity": {
                    "type": ".squareup.legalentities.model.LegalEntity",
                    "id": 2,
                    "rule": "optional"
                  },
                  "jurisdiction": {
                    "type": ".squareup.common.countries.Country",
                    "id": 3,
                    "rule": "optional"
                  },
                  "updatedToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "auditLogEntry": {
                    "type": ".squareup.legalentities.model.AuditLogEntry",
                    "id": 5,
                    "rule": "optional"
                  },
                  "deletedNodes": {
                    "type": "string",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "product": {
                    "type": ".squareup.legalentities.verification.Product",
                    "id": 10,
                    "rule": "optional"
                  },
                  "purpose": {
                    "type": ".squareup.legalentities.model.Structure.Purpose",
                    "id": 11,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Purpose": {
                    "values": {
                      "ONBOARDING": 0,
                      "ACCOUNT_TRANSFER": 1,
                      "EXTERNAL": 2,
                      "OTHER": 3
                    }
                  }
                }
              },
              "LegalEntity": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "relationships": {
                    "type": ".squareup.legalentities.model.LegalEntity.Relationship",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "redacted": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "individual": {
                    "type": ".squareup.legalentities.model.Individual",
                    "id": 10
                  },
                  "business": {
                    "type": ".squareup.legalentities.model.Business",
                    "id": 11
                  }
                },
                "nested": {
                  "Relationship": {
                    "fields": {
                      "metadata": {
                        "type": ".squareup.legalentities.model.FieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "legalEntity": {
                        "type": ".squareup.legalentities.model.LegalEntity",
                        "id": 11,
                        "rule": "optional"
                      },
                      "businessControlRelationship": {
                        "type": ".squareup.legalentities.model.Business.ControlRelationship",
                        "id": 20
                      }
                    },
                    "nested": {
                      "relationship": {
                        "oneof": ["businessControlRelationship"]
                      }
                    }
                  },
                  "data": {
                    "oneof": ["individual", "business"]
                  }
                }
              },
              "Individual": {
                "fields": {
                  "name": {
                    "type": ".squareup.legalentities.model.Individual.Name",
                    "id": 1,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.legalentities.model.Address",
                    "id": 2,
                    "rule": "optional"
                  },
                  "birthDate": {
                    "type": ".squareup.legalentities.model.Individual.BirthDate",
                    "id": 3,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": ".squareup.legalentities.model.PhoneNumber",
                    "id": 4,
                    "rule": "optional"
                  },
                  "gender": {
                    "type": ".squareup.legalentities.model.Individual.Gender",
                    "id": 5,
                    "rule": "optional"
                  },
                  "email": {
                    "type": ".squareup.legalentities.model.Individual.Email",
                    "id": 6,
                    "rule": "optional"
                  },
                  "incorrectData": {
                    "type": ".squareup.legalentities.model.IncorrectData",
                    "id": 7,
                    "rule": "optional"
                  },
                  "governmentIdData": {
                    "type": ".squareup.legalentities.model.Individual.GovernmentIdData",
                    "id": 8,
                    "rule": "optional"
                  },
                  "auData": {
                    "type": ".squareup.legalentities.model.Individual.AuData",
                    "id": 22
                  },
                  "caData": {
                    "type": ".squareup.legalentities.model.Individual.CaData",
                    "id": 21
                  },
                  "esData": {
                    "type": ".squareup.legalentities.model.Individual.EsData",
                    "id": 28
                  },
                  "frData": {
                    "type": ".squareup.legalentities.model.Individual.FrData",
                    "id": 25
                  },
                  "gbData": {
                    "type": ".squareup.legalentities.model.Individual.GbData",
                    "id": 24
                  },
                  "jpData": {
                    "type": ".squareup.legalentities.model.Individual.JpData",
                    "id": 23
                  },
                  "mxData": {
                    "type": ".squareup.legalentities.model.Individual.MxData",
                    "id": 30
                  },
                  "ptData": {
                    "type": ".squareup.legalentities.model.Individual.PtData",
                    "id": 29
                  },
                  "usData": {
                    "type": ".squareup.legalentities.model.Individual.UsData",
                    "id": 20
                  },
                  "ieData": {
                    "type": ".squareup.legalentities.model.Individual.IeData",
                    "id": 27
                  },
                  "governmentData": {
                    "type": ".squareup.legalentities.model.Individual.GovernmentData",
                    "id": 26
                  }
                },
                "nested": {
                  "Name": {
                    "fields": {
                      "metadata": {
                        "type": ".squareup.legalentities.model.FieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "familyName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "givenName": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "middleName": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "Gender": {
                    "fields": {
                      "metadata": {
                        "type": ".squareup.legalentities.model.FieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "value": {
                        "type": ".squareup.legalentities.model.Individual.Gender.Value",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Value": {
                        "values": {
                          "GENDER_VALUE_NOT_SET": 0,
                          "FEMALE": 1,
                          "MALE": 2
                        }
                      }
                    }
                  },
                  "BirthDate": {
                    "fields": {
                      "metadata": {
                        "type": ".squareup.legalentities.model.FieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "value": {
                        "type": ".squareup.common.time.YearMonthDay",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "Email": {
                    "fields": {
                      "metadata": {
                        "type": ".squareup.legalentities.model.FieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "value": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "SsnLastFour": {
                    "fields": {
                      "metadata": {
                        "type": ".squareup.legalentities.model.FieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "value": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "AuData": {
                    "fields": {
                      "document": {
                        "type": ".squareup.legalentities.model.Document",
                        "id": 1,
                        "rule": "optional"
                      },
                      "dvsHeaderOptIn": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "creditHeaderOptIn": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "CaData": {
                    "fields": {
                      "sinFideliusToken": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "FrData": {
                    "fields": {}
                  },
                  "EsData": {
                    "fields": {}
                  },
                  "PtData": {
                    "fields": {}
                  },
                  "GbData": {
                    "fields": {}
                  },
                  "MxData": {
                    "fields": {}
                  },
                  "GovernmentData": {
                    "fields": {
                      "governmentIdFideliusToken": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "type": {
                        "type": ".squareup.legalentities.model.Individual.GovernmentData.GovernmentIdType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "issuingCountry": {
                        "type": ".squareup.common.countries.Country",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "GovernmentIdType": {
                        "values": {
                          "T_DO_NOT_USE": 0,
                          "PASSPORT": 1,
                          "DRIVERS_LICENSE": 2,
                          "ID_CARD": 3,
                          "RESIDENCE_PERMIT": 4
                        }
                      }
                    }
                  },
                  "GovernmentIdData": {
                    "fields": {
                      "governmentIdFideliusToken": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "type": {
                        "type": ".squareup.legalentities.model.Individual.GovernmentIdData.GovernmentIdType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "issuingCountry": {
                        "type": ".squareup.common.countries.Country",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "GovernmentIdType": {
                        "values": {
                          "T_DO_NOT_USE": 0,
                          "PASSPORT": 1,
                          "DRIVERS_LICENSE": 2,
                          "ID_CARD": 3,
                          "RESIDENCE_PERMIT": 4
                        }
                      }
                    }
                  },
                  "JpData": {
                    "fields": {
                      "kanjiName": {
                        "type": ".squareup.legalentities.model.Individual.Name",
                        "id": 1,
                        "rule": "optional"
                      },
                      "katakanaName": {
                        "type": ".squareup.legalentities.model.Individual.Name",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "UsData": {
                    "fields": {
                      "ssnLastFour": {
                        "type": ".squareup.legalentities.model.Individual.SsnLastFour",
                        "id": 1,
                        "rule": "optional"
                      },
                      "ssnFideliusToken": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "IeData": {
                    "fields": {
                      "ppsnFideliusToken": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "country_data": {
                    "oneof": ["auData", "caData", "esData", "frData", "gbData", "jpData", "mxData", "ptData", "usData", "ieData", "governmentData"]
                  }
                }
              },
              "IncorrectData": {
                "fields": {
                  "metadata": {
                    "type": ".squareup.legalentities.model.FieldMetadata",
                    "id": 1,
                    "rule": "optional"
                  },
                  "value": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "Business": {
                "fields": {
                  "structure": {
                    "type": ".squareup.legalentities.model.Business.Structure",
                    "id": 2,
                    "rule": "optional"
                  },
                  "legalName": {
                    "type": ".squareup.legalentities.model.Business.Name",
                    "id": 3,
                    "rule": "optional"
                  },
                  "tradingName": {
                    "type": ".squareup.legalentities.model.Business.Name",
                    "id": 31,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.legalentities.model.Address",
                    "id": 4,
                    "rule": "optional"
                  },
                  "tradingAddress": {
                    "type": ".squareup.legalentities.model.Address",
                    "id": 30,
                    "rule": "optional"
                  },
                  "incompleteOwners": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": ".squareup.legalentities.model.PhoneNumber",
                    "id": 6,
                    "rule": "optional"
                  },
                  "website": {
                    "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                    "id": 32,
                    "rule": "optional"
                  },
                  "ownershipStructure": {
                    "type": ".squareup.onboard.activation.common.OwnershipStructure",
                    "id": 33,
                    "rule": "optional"
                  },
                  "mobileBusiness": {
                    "type": "bool",
                    "id": 34,
                    "rule": "optional"
                  },
                  "documentFiles": {
                    "type": ".squareup.legalentities.model.Business.DocumentFile",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "incorrectData": {
                    "type": ".squareup.legalentities.model.IncorrectData",
                    "id": 8,
                    "rule": "optional"
                  },
                  "industry": {
                    "type": ".squareup.legalentities.model.Business.Industry",
                    "id": 9,
                    "rule": "optional"
                  },
                  "auData": {
                    "type": ".squareup.legalentities.model.Business.AuData",
                    "id": 22
                  },
                  "caData": {
                    "type": ".squareup.legalentities.model.Business.CaData",
                    "id": 21
                  },
                  "esData": {
                    "type": ".squareup.legalentities.model.Business.EsData",
                    "id": 28
                  },
                  "gbData": {
                    "type": ".squareup.legalentities.model.Business.GbData",
                    "id": 24
                  },
                  "frData": {
                    "type": ".squareup.legalentities.model.Business.FrData",
                    "id": 27
                  },
                  "ieData": {
                    "type": ".squareup.legalentities.model.Business.IeData",
                    "id": 26
                  },
                  "jpData": {
                    "type": ".squareup.legalentities.model.Business.JpData",
                    "id": 23
                  },
                  "mxData": {
                    "type": ".squareup.legalentities.model.Business.MxData",
                    "id": 35
                  },
                  "ptData": {
                    "type": ".squareup.legalentities.model.Business.PtData",
                    "id": 29
                  },
                  "usData": {
                    "type": ".squareup.legalentities.model.Business.UsData",
                    "id": 20
                  }
                },
                "nested": {
                  "DocumentFile": {
                    "fields": {
                      "metadata": {
                        "type": ".squareup.legalentities.model.FieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "documentType": {
                        "type": ".squareup.legalentities.model.Business.DocumentFile.DocumentType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "docboxToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "DocumentType": {
                        "values": {
                          "DOCUMENT_TYPE_UNDEFINED": 0,
                          "TRUST_DEED": 1,
                          "ANNUAL_GENERAL_MEETING_MINUTES": 2,
                          "CERTIFICATE_OF_INCORPORATION": 3,
                          "PROOF_OF_BUSINESS_REGISTRATION": 4
                        }
                      }
                    }
                  },
                  "Industry": {
                    "values": {
                      "INDUSTRY_UNDEFINED": 0,
                      "CANNABIS": 1
                    }
                  },
                  "Structure": {
                    "fields": {
                      "metadata": {
                        "type": ".squareup.legalentities.model.FieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "type": {
                        "type": ".squareup.legalentities.model.Business.Structure.Type",
                        "id": 2,
                        "rule": "optional"
                      },
                      "rawStructure": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Type": {
                        "values": {
                          "STRUCTURE_VALUE_NOT_SET": 1,
                          "UNKNOWN": 2,
                          "INDIVIDUAL_SOLE_TRADER": 3,
                          "COMPANY": 4,
                          "PARTNERSHIP": 5,
                          "TRUST": 6,
                          "GOVERNMENT_BODY": 7,
                          "COOPERATIVE": 8,
                          "SOLE_PROPRIETORSHIP": 9,
                          "C_CORPORATION": 10,
                          "S_CORPORATION": 11,
                          "LIMITED_LIABILITY_COMPANY": 12,
                          "INDEPENDENT_CONTRACTOR": 13,
                          "SELF_EMPLOYED": 14,
                          "NONPROFIT": 15,
                          "VETERANS_ORGANIZATION": 16,
                          "TRIBAL_BUSINESS": 17,
                          "OTHER": 18,
                          "APPOINTOR_TRUST": 19,
                          "UNIT_TRUST": 20,
                          "INCORPORATED_ASSOCIATION": 21,
                          "UNINCORPORATED_ASSOCIATION": 22,
                          "UNKNOWN_ASSOCIATION": 23,
                          "UNKNOWN_TRUST": 24,
                          "LIMITED_COMPANY": 25,
                          "LIMITED_COMPANY_DIRECTOR_OR_BO": 26,
                          "LIMITED_COMPANY_MANUAL": 27,
                          "LIMITED_PARTNERSHIP": 28,
                          "EI": 29,
                          "EIRL": 32,
                          "SARL": 30,
                          "EURL": 33,
                          "EARL": 34,
                          "SA": 35,
                          "SAS": 36,
                          "SASU": 37,
                          "SNC": 31,
                          "SC": 38,
                          "SCS": 39,
                          "SCA": 40,
                          "AUTONOMO": 41,
                          "EMPRESARIO_INDIVIDUAL": 42,
                          "SL": 43,
                          "SLU": 44,
                          "SLP": 45,
                          "SLL": 46,
                          "SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": 47,
                          "PUBLIC_COMPANY": 48,
                          "CIVIL_COMPANY": 49,
                          "COOPERATIVE_COMPANY": 50,
                          "GENERAL_PARTNERSHIP": 51,
                          "ES_LIMITED_PARTNERSHIP": 52,
                          "CORPORATION": 53,
                          "JAPAN_COMPANY": 54,
                          "KYB_LIMITED_COMPANY": 55,
                          "KYB_LIMITED_LIABILITY_COMPANY": 56,
                          "KYB_PARTNERSHIP": 57,
                          "KYB_PUBLIC_COMPANY": 58,
                          "KYB_OTHER": 59,
                          "KYB_COMPANY": 60,
                          "KYB_NONPROFIT": 61
                        }
                      }
                    }
                  },
                  "Name": {
                    "fields": {
                      "metadata": {
                        "type": ".squareup.legalentities.model.FieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "value": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ControlRelationship": {
                    "fields": {
                      "role": {
                        "type": ".squareup.legalentities.model.Business.ControlRelationship.Role",
                        "id": 2,
                        "rule": "optional"
                      },
                      "ownership": {
                        "type": ".squareup.legalentities.model.Business.ControlRelationship.Ownership",
                        "id": 3,
                        "rule": "optional"
                      },
                      "ownershipPercentage": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "primaryIndividual": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "authorizedRepresentative": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      }
                    },
                    "nested": {
                      "Ownership": {
                        "values": {
                          "OWNERSHIP_NOT_SET": 0,
                          "NO_OWNERSHIP": 1,
                          "NON_SIGNIFICANT": 2,
                          "BENEFICIAL": 3
                        }
                      },
                      "Role": {
                        "values": {
                          "ROLE_NOT_SET": 0,
                          "NO_ROLE": 1,
                          "MANAGER": 2,
                          "DIRECTOR": 3,
                          "PARTNER": 4,
                          "TRUST_BENEFICIARY": 5,
                          "TRUST_HOLDER": 6,
                          "SOLE_TRADER": 7,
                          "OFFICER_OR_AGENT": 8,
                          "SECRETARY": 9,
                          "SOLE_DIRECTOR": 10,
                          "COMPANY_DIRECTORS": 11,
                          "TRUSTEE": 12,
                          "APPOINTER_OR_PRINCIPAL": 13,
                          "TREASURER_OR_FINANCIAL_CONTROLLER": 14,
                          "PRESIDENT_OR_CHAIRMAN_OR_CEO": 15,
                          "BUSINESS_MANAGER": 16,
                          "CEO": 17,
                          "CFO": 18,
                          "COO": 19,
                          "MANAGING_MEMBER": 20,
                          "GENERAL_PARTNER": 21,
                          "PRESIDENT": 22,
                          "VICE_PRESIDENT": 23,
                          "TREASURER": 24,
                          "OTHER_MANAGER": 25,
                          "NON_MANAGER": 26,
                          "TAXPAYER": 27,
                          "SETTLOR": 28,
                          "UNIT_HOLDER": 29,
                          "APPOINTOR": 30,
                          "SQ_ACCOUNT_HOLDER": 31,
                          "BUSINESS_OWNER": 32,
                          "PERSON_WITH_SIGNIFICANT_CONTROL": 33,
                          "BUSINESS_OWNER_AND_PERSON_WITH_SIGNIFICANT_CONTROL": 34
                        }
                      }
                    }
                  },
                  "AuData": {
                    "fields": {
                      "abn": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "acn": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 2,
                        "rule": "optional"
                      },
                      "incorporationNumber": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "CaData": {
                    "fields": {
                      "craBusinessNumber": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "businessRegistrationNumber": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 2,
                        "rule": "optional"
                      },
                      "doingBusinessAs": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 3,
                        "rule": "optional"
                      },
                      "registeredCharity": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      },
                      "acceptsPublicDonations": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  },
                  "GbData": {
                    "fields": {
                      "chrn": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "locationAddress": {
                        "type": ".squareup.legalentities.model.Address",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "FrData": {
                    "fields": {
                      "siretNumber": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "rcsNumber": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 2,
                        "rule": "optional"
                      },
                      "countryOfRegistration": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 3,
                        "rule": "optional"
                      },
                      "tradingName": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 4,
                        "rule": "optional"
                      },
                      "vatNumber": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 5,
                        "rule": "optional"
                      },
                      "tradingAddress": {
                        "type": ".squareup.legalentities.model.Address",
                        "id": 6,
                        "rule": "optional"
                      },
                      "nafCode": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 7,
                        "rule": "optional"
                      },
                      "sharesCapital": {
                        "type": ".squareup.common.Money",
                        "id": 9,
                        "rule": "optional"
                      }
                    }
                  },
                  "IeData": {
                    "fields": {
                      "businessRegistrationNumber": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "countryOfRegistration": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 2,
                        "rule": "optional"
                      },
                      "tradingName": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 3,
                        "rule": "optional"
                      },
                      "tradingAddress": {
                        "type": ".squareup.legalentities.model.Address",
                        "id": 4,
                        "rule": "optional"
                      },
                      "vatNumber": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 5,
                        "rule": "optional"
                      },
                      "corporateTaxId": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  },
                  "EsData": {
                    "fields": {
                      "taxIdentificationNumber": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "countryOfRegistration": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 2,
                        "rule": "optional"
                      },
                      "tradingName": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 3,
                        "rule": "optional"
                      },
                      "tradingAddress": {
                        "type": ".squareup.legalentities.model.Address",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "JpData": {
                    "fields": {
                      "jcbApplicationInfo": {
                        "type": ".squareup.legalentities.model.Business.JpData.JcbApplicationInfo",
                        "id": 1,
                        "rule": "optional"
                      },
                      "kanjiName": {
                        "type": ".squareup.legalentities.model.Business.Name",
                        "id": 2,
                        "rule": "optional"
                      },
                      "katakanaName": {
                        "type": ".squareup.legalentities.model.Business.Name",
                        "id": 3,
                        "rule": "optional"
                      },
                      "phoneNumber": {
                        "type": ".squareup.legalentities.model.PhoneNumber",
                        "id": 4,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "JcbApplicationInfo": {
                        "fields": {
                          "metadata": {
                            "type": ".squareup.legalentities.model.FieldMetadata",
                            "id": 1,
                            "rule": "optional"
                          },
                          "administrativeAction": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          },
                          "administrativeActionNote": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "corporateNumber": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "licenseNumber": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "licenseHolderName": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "licenseType": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "MxData": {
                    "fields": {
                      "taxId": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  },
                  "PtData": {
                    "fields": {
                      "taxIdentificationNumber": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      },
                      "countryOfRegistration": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 2,
                        "rule": "optional"
                      },
                      "tradingName": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 3,
                        "rule": "optional"
                      },
                      "tradingAddress": {
                        "type": ".squareup.legalentities.model.Address",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "UsData": {
                    "fields": {
                      "einFideliusToken": {
                        "type": ".squareup.legalentities.model.StringWithFieldMetadata",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "country_data": {
                    "oneof": ["auData", "caData", "esData", "gbData", "frData", "ieData", "jpData", "mxData", "ptData", "usData"]
                  }
                }
              },
              "StringWithFieldMetadata": {
                "fields": {
                  "metadata": {
                    "type": ".squareup.legalentities.model.FieldMetadata",
                    "id": 1,
                    "rule": "optional"
                  },
                  "value": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Address": {
                "fields": {
                  "metadata": {
                    "type": ".squareup.legalentities.model.FieldMetadata",
                    "id": 1,
                    "rule": "optional"
                  },
                  "addressToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.common.address.Address",
                    "id": 4,
                    "rule": "optional"
                  },
                  "jpData": {
                    "type": ".squareup.legalentities.model.Address.JpData",
                    "id": 3
                  }
                },
                "nested": {
                  "JpData": {
                    "fields": {
                      "agrexCode": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "prefectureIsoCode": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "country_data": {
                    "oneof": ["jpData"]
                  }
                }
              },
              "PhoneNumber": {
                "fields": {
                  "metadata": {
                    "type": ".squareup.legalentities.model.FieldMetadata",
                    "id": 1,
                    "rule": "optional"
                  },
                  "value": {
                    "type": ".squareup.common.location.Phone",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FieldMetadata": {
                "fields": {
                  "quality": {
                    "type": ".squareup.legalentities.model.FieldMetadata.Quality",
                    "id": 1,
                    "rule": "optional"
                  },
                  "source": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Quality": {
                    "values": {
                      "QUALITY_NOT_SET": 0,
                      "USER_INPUT": 1,
                      "FUZZY_MATCH": 5,
                      "STRICT_MATCH": 6,
                      "APPROVED_MANUAL_MODIFICATION": 9,
                      "VENDOR_LOOKUP": 10
                    }
                  }
                }
              },
              "AuditLogEntry": {
                "fields": {
                  "serviceOu": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "agentUid": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "updateReason": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "Document": {
                "fields": {
                  "metadata": {
                    "type": ".squareup.legalentities.model.FieldMetadata",
                    "id": 1,
                    "rule": "optional"
                  },
                  "passport": {
                    "type": ".squareup.legalentities.model.Document.Passport",
                    "id": 2
                  },
                  "driversLicense": {
                    "type": ".squareup.legalentities.model.Document.DriversLicense",
                    "id": 3
                  },
                  "medicare": {
                    "type": ".squareup.legalentities.model.Document.Medicare",
                    "id": 4
                  }
                },
                "nested": {
                  "Passport": {
                    "fields": {
                      "country": {
                        "type": ".squareup.common.countries.Country",
                        "id": 1,
                        "rule": "optional"
                      },
                      "number": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "gender": {
                        "type": ".squareup.legalentities.model.Document.Passport.Gender",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Gender": {
                        "values": {
                          "GENDER_NOT_SET": 0,
                          "MALE": 1,
                          "FEMALE": 2
                        }
                      }
                    }
                  },
                  "DriversLicense": {
                    "fields": {
                      "stateCode": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "number": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "cardNumber": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "Medicare": {
                    "fields": {
                      "cardNumber": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "referenceNumber": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "middleNameOnCard": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "expirationDate": {
                        "type": ".squareup.common.time.YearMonthDay",
                        "id": 4,
                        "rule": "optional"
                      },
                      "cardColor": {
                        "type": ".squareup.legalentities.model.Document.Medicare.CardColor",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "CardColor": {
                        "values": {
                          "CARD_COLOR_NOT_SET": 0,
                          "GREEN": 1,
                          "BLUE": 2,
                          "YELLOW": 3
                        }
                      }
                    }
                  },
                  "document": {
                    "oneof": ["passport", "driversLicense", "medicare"]
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Structure && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Structure?.nested?.Purpose && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.LegalEntity && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.LegalEntity?.nested?.Relationship && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.Name && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.Gender && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.Gender?.nested?.Value && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.BirthDate && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.Email && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.SsnLastFour && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.AuData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.CaData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.FrData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.EsData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.PtData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.GbData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.MxData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.GovernmentData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.GovernmentData?.nested?.GovernmentIdType && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.GovernmentIdData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.GovernmentIdData?.nested?.GovernmentIdType && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.JpData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.UsData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Individual?.nested?.IeData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.IncorrectData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.DocumentFile && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.DocumentFile?.nested?.DocumentType && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.Industry && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.Structure && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.Structure?.nested?.Type && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.Name && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.ControlRelationship && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.ControlRelationship?.nested?.Ownership && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.ControlRelationship?.nested?.Role && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.AuData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.CaData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.GbData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.FrData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.IeData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.EsData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.JpData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.JpData?.nested?.JcbApplicationInfo && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.MxData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.PtData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Business?.nested?.UsData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.StringWithFieldMetadata && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Address && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Address?.nested?.JpData && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.PhoneNumber && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.FieldMetadata && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.FieldMetadata?.nested?.Quality && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.AuditLogEntry && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Document && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Document?.nested?.Passport && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Document?.nested?.Passport?.nested?.Gender && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Document?.nested?.DriversLicense && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Document?.nested?.Medicare && !$root.nested?.squareup?.nested?.legalentities?.nested?.model?.nested?.Document?.nested?.Medicare?.nested?.CardColor) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Structure @ squareup/legalentities/model/model.proto at 16:1
 */
export const Structure = $root.lookupType('squareup.legalentities.model.Structure');
fixType(Structure);
Builder.createAndAttachToType(Structure);
/**
 * SOURCE Purpose @ squareup/legalentities/model/model.proto at 58:3
 */
Structure.Purpose = $root.lookupEnum('squareup.legalentities.model.Structure.Purpose').values;
/**
 * SOURCE LegalEntity @ squareup/legalentities/model/model.proto at 66:1
 */
export const LegalEntity = $root.lookupType('squareup.legalentities.model.LegalEntity');
fixType(LegalEntity);
Builder.createAndAttachToType(LegalEntity);
/**
 * SOURCE Relationship @ squareup/legalentities/model/model.proto at 93:3
 */
LegalEntity.Relationship = $root.lookupType('squareup.legalentities.model.LegalEntity.Relationship');
fixType(LegalEntity.Relationship);
Builder.createAndAttachToType(LegalEntity.Relationship);
/**
 * Representation for a natural person.
 *
 * SOURCE Individual @ squareup/legalentities/model/model.proto at 111:1
 */
export const Individual = $root.lookupType('squareup.legalentities.model.Individual');
fixType(Individual);
Builder.createAndAttachToType(Individual);
/**
 * SOURCE Name @ squareup/legalentities/model/model.proto at 148:3
 */
Individual.Name = $root.lookupType('squareup.legalentities.model.Individual.Name');
fixType(Individual.Name);
Builder.createAndAttachToType(Individual.Name);
/**
 * SOURCE Gender @ squareup/legalentities/model/model.proto at 155:3
 */
Individual.Gender = $root.lookupType('squareup.legalentities.model.Individual.Gender');
fixType(Individual.Gender);
Builder.createAndAttachToType(Individual.Gender);
/**
 * SOURCE Value @ squareup/legalentities/model/model.proto at 160:5
 */
Individual.Gender.Value = $root.lookupEnum('squareup.legalentities.model.Individual.Gender.Value').values;
/**
 * SOURCE BirthDate @ squareup/legalentities/model/model.proto at 168:3
 */
Individual.BirthDate = $root.lookupType('squareup.legalentities.model.Individual.BirthDate');
fixType(Individual.BirthDate);
Builder.createAndAttachToType(Individual.BirthDate);
/**
 * SOURCE Email @ squareup/legalentities/model/model.proto at 173:3
 */
Individual.Email = $root.lookupType('squareup.legalentities.model.Individual.Email');
fixType(Individual.Email);
Builder.createAndAttachToType(Individual.Email);
/**
 * SOURCE SsnLastFour @ squareup/legalentities/model/model.proto at 178:3
 */
Individual.SsnLastFour = $root.lookupType('squareup.legalentities.model.Individual.SsnLastFour');
fixType(Individual.SsnLastFour);
Builder.createAndAttachToType(Individual.SsnLastFour);
/**
 * SOURCE AuData @ squareup/legalentities/model/model.proto at 183:3
 */
Individual.AuData = $root.lookupType('squareup.legalentities.model.Individual.AuData');
fixType(Individual.AuData);
Builder.createAndAttachToType(Individual.AuData);
/**
 * SOURCE CaData @ squareup/legalentities/model/model.proto at 189:3
 */
Individual.CaData = $root.lookupType('squareup.legalentities.model.Individual.CaData');
fixType(Individual.CaData);
Builder.createAndAttachToType(Individual.CaData);
/**
 * SOURCE FrData @ squareup/legalentities/model/model.proto at 194:3
 */
Individual.FrData = $root.lookupType('squareup.legalentities.model.Individual.FrData');
fixType(Individual.FrData);
Builder.createAndAttachToType(Individual.FrData);
/**
 * SOURCE EsData @ squareup/legalentities/model/model.proto at 197:3
 */
Individual.EsData = $root.lookupType('squareup.legalentities.model.Individual.EsData');
fixType(Individual.EsData);
Builder.createAndAttachToType(Individual.EsData);
/**
 * SOURCE PtData @ squareup/legalentities/model/model.proto at 200:3
 */
Individual.PtData = $root.lookupType('squareup.legalentities.model.Individual.PtData');
fixType(Individual.PtData);
Builder.createAndAttachToType(Individual.PtData);
/**
 * SOURCE GbData @ squareup/legalentities/model/model.proto at 203:3
 */
Individual.GbData = $root.lookupType('squareup.legalentities.model.Individual.GbData');
fixType(Individual.GbData);
Builder.createAndAttachToType(Individual.GbData);
/**
 * SOURCE MxData @ squareup/legalentities/model/model.proto at 206:3
 */
Individual.MxData = $root.lookupType('squareup.legalentities.model.Individual.MxData');
fixType(Individual.MxData);
Builder.createAndAttachToType(Individual.MxData);
/**
 * SOURCE GovernmentData @ squareup/legalentities/model/model.proto at 209:3
 */
Individual.GovernmentData = $root.lookupType('squareup.legalentities.model.Individual.GovernmentData');
fixType(Individual.GovernmentData);
Builder.createAndAttachToType(Individual.GovernmentData);
/**
 * SOURCE GovernmentIdType @ squareup/legalentities/model/model.proto at 219:5
 */
Individual.GovernmentData.GovernmentIdType = $root.lookupEnum('squareup.legalentities.model.Individual.GovernmentData.GovernmentIdType').values;
/**
 * SOURCE GovernmentIdData @ squareup/legalentities/model/model.proto at 228:3
 */
Individual.GovernmentIdData = $root.lookupType('squareup.legalentities.model.Individual.GovernmentIdData');
fixType(Individual.GovernmentIdData);
Builder.createAndAttachToType(Individual.GovernmentIdData);
/**
 * SOURCE GovernmentIdType @ squareup/legalentities/model/model.proto at 238:5
 */
Individual.GovernmentIdData.GovernmentIdType = $root.lookupEnum('squareup.legalentities.model.Individual.GovernmentIdData.GovernmentIdType').values;
/**
 * SOURCE JpData @ squareup/legalentities/model/model.proto at 247:3
 */
Individual.JpData = $root.lookupType('squareup.legalentities.model.Individual.JpData');
fixType(Individual.JpData);
Builder.createAndAttachToType(Individual.JpData);
/**
 * SOURCE UsData @ squareup/legalentities/model/model.proto at 255:3
 */
Individual.UsData = $root.lookupType('squareup.legalentities.model.Individual.UsData');
fixType(Individual.UsData);
Builder.createAndAttachToType(Individual.UsData);
/**
 * SOURCE IeData @ squareup/legalentities/model/model.proto at 263:3
 */
Individual.IeData = $root.lookupType('squareup.legalentities.model.Individual.IeData');
fixType(Individual.IeData);
Builder.createAndAttachToType(Individual.IeData);
/**
 * SOURCE IncorrectData @ squareup/legalentities/model/model.proto at 270:1
 */
export const IncorrectData = $root.lookupType('squareup.legalentities.model.IncorrectData');
fixType(IncorrectData);
Builder.createAndAttachToType(IncorrectData);
/**
 * SOURCE Business @ squareup/legalentities/model/model.proto at 278:1
 */
export const Business = $root.lookupType('squareup.legalentities.model.Business');
fixType(Business);
Builder.createAndAttachToType(Business);
/**
 * A DocumentFile holds metadata about a file that is related to a legal entity node.
 *
 * SOURCE DocumentFile @ squareup/legalentities/model/model.proto at 312:3
 */
Business.DocumentFile = $root.lookupType('squareup.legalentities.model.Business.DocumentFile');
fixType(Business.DocumentFile);
Builder.createAndAttachToType(Business.DocumentFile);
/**
 * DocumentType describes the kinds of documents that are relevant to a legal entity. New
 * values can be added as needed. This is just a collection of well-known strings.
 *
 * SOURCE DocumentType @ squareup/legalentities/model/model.proto at 319:5
 */
Business.DocumentFile.DocumentType = $root.lookupEnum('squareup.legalentities.model.Business.DocumentFile.DocumentType').values;
/**
 * SOURCE Industry @ squareup/legalentities/model/model.proto at 328:3
 */
Business.Industry = $root.lookupEnum('squareup.legalentities.model.Business.Industry').values;
/**
 * The legal structure of the business entity.
 *
 * SOURCE Structure @ squareup/legalentities/model/model.proto at 352:3
 */
Business.Structure = $root.lookupType('squareup.legalentities.model.Business.Structure');
fixType(Business.Structure);
Builder.createAndAttachToType(Business.Structure);
/**
 * SOURCE Type @ squareup/legalentities/model/model.proto at 359:5
 */
Business.Structure.Type = $root.lookupEnum('squareup.legalentities.model.Business.Structure.Type').values;
/**
 * Legal business name
 *
 * SOURCE Name @ squareup/legalentities/model/model.proto at 462:3
 */
Business.Name = $root.lookupType('squareup.legalentities.model.Business.Name');
fixType(Business.Name);
Builder.createAndAttachToType(Business.Name);
/**
 * SOURCE ControlRelationship @ squareup/legalentities/model/model.proto at 467:3
 */
Business.ControlRelationship = $root.lookupType('squareup.legalentities.model.Business.ControlRelationship');
fixType(Business.ControlRelationship);
Builder.createAndAttachToType(Business.ControlRelationship);
/**
 * SOURCE Ownership @ squareup/legalentities/model/model.proto at 481:5
 */
Business.ControlRelationship.Ownership = $root.lookupEnum('squareup.legalentities.model.Business.ControlRelationship.Ownership').values;
/**
 * SOURCE Role @ squareup/legalentities/model/model.proto at 490:5
 */
Business.ControlRelationship.Role = $root.lookupEnum('squareup.legalentities.model.Business.ControlRelationship.Role').values;
/**
 * Country specific data
 *
 * SOURCE AuData @ squareup/legalentities/model/model.proto at 544:3
 */
Business.AuData = $root.lookupType('squareup.legalentities.model.Business.AuData');
fixType(Business.AuData);
Builder.createAndAttachToType(Business.AuData);
/**
 * SOURCE CaData @ squareup/legalentities/model/model.proto at 556:3
 */
Business.CaData = $root.lookupType('squareup.legalentities.model.Business.CaData');
fixType(Business.CaData);
Builder.createAndAttachToType(Business.CaData);
/**
 * SOURCE GbData @ squareup/legalentities/model/model.proto at 573:3
 */
Business.GbData = $root.lookupType('squareup.legalentities.model.Business.GbData');
fixType(Business.GbData);
Builder.createAndAttachToType(Business.GbData);
/**
 * SOURCE FrData @ squareup/legalentities/model/model.proto at 579:3
 */
Business.FrData = $root.lookupType('squareup.legalentities.model.Business.FrData');
fixType(Business.FrData);
Builder.createAndAttachToType(Business.FrData);
/**
 * SOURCE IeData @ squareup/legalentities/model/model.proto at 591:3
 */
Business.IeData = $root.lookupType('squareup.legalentities.model.Business.IeData');
fixType(Business.IeData);
Builder.createAndAttachToType(Business.IeData);
/**
 * SOURCE EsData @ squareup/legalentities/model/model.proto at 602:3
 */
Business.EsData = $root.lookupType('squareup.legalentities.model.Business.EsData');
fixType(Business.EsData);
Builder.createAndAttachToType(Business.EsData);
/**
 * SOURCE JpData @ squareup/legalentities/model/model.proto at 610:3
 */
Business.JpData = $root.lookupType('squareup.legalentities.model.Business.JpData');
fixType(Business.JpData);
Builder.createAndAttachToType(Business.JpData);
/**
 * Fields related to activating for JCB payments
 *
 * SOURCE JcbApplicationInfo @ squareup/legalentities/model/model.proto at 622:5
 */
Business.JpData.JcbApplicationInfo = $root.lookupType('squareup.legalentities.model.Business.JpData.JcbApplicationInfo');
fixType(Business.JpData.JcbApplicationInfo);
Builder.createAndAttachToType(Business.JpData.JcbApplicationInfo);
/**
 * SOURCE MxData @ squareup/legalentities/model/model.proto at 638:3
 */
Business.MxData = $root.lookupType('squareup.legalentities.model.Business.MxData');
fixType(Business.MxData);
Builder.createAndAttachToType(Business.MxData);
/**
 * SOURCE PtData @ squareup/legalentities/model/model.proto at 642:3
 */
Business.PtData = $root.lookupType('squareup.legalentities.model.Business.PtData');
fixType(Business.PtData);
Builder.createAndAttachToType(Business.PtData);
/**
 * SOURCE UsData @ squareup/legalentities/model/model.proto at 650:3
 */
Business.UsData = $root.lookupType('squareup.legalentities.model.Business.UsData');
fixType(Business.UsData);
Builder.createAndAttachToType(Business.UsData);
/**
 * Fields
 *
 * SOURCE StringWithFieldMetadata @ squareup/legalentities/model/model.proto at 661:1
 */
export const StringWithFieldMetadata = $root.lookupType('squareup.legalentities.model.StringWithFieldMetadata');
fixType(StringWithFieldMetadata);
Builder.createAndAttachToType(StringWithFieldMetadata);
/**
 * An address in any country (not necessarily the LegalEntity structure's country jurisdiction)
 * represented as an Address service token or as plain text address (squareup.common.address.Address)
 *
 * SOURCE Address @ squareup/legalentities/model/model.proto at 670:1
 */
export const Address = $root.lookupType('squareup.legalentities.model.Address');
fixType(Address);
Builder.createAndAttachToType(Address);
/**
 * SOURCE JpData @ squareup/legalentities/model/model.proto at 682:3
 */
Address.JpData = $root.lookupType('squareup.legalentities.model.Address.JpData');
fixType(Address.JpData);
Builder.createAndAttachToType(Address.JpData);
/**
 * SOURCE PhoneNumber @ squareup/legalentities/model/model.proto at 695:1
 */
export const PhoneNumber = $root.lookupType('squareup.legalentities.model.PhoneNumber');
fixType(PhoneNumber);
Builder.createAndAttachToType(PhoneNumber);
/**
 * SOURCE FieldMetadata @ squareup/legalentities/model/model.proto at 700:1
 */
export const FieldMetadata = $root.lookupType('squareup.legalentities.model.FieldMetadata');
fixType(FieldMetadata);
Builder.createAndAttachToType(FieldMetadata);
/**
 * SOURCE Quality @ squareup/legalentities/model/model.proto at 704:3
 */
FieldMetadata.Quality = $root.lookupEnum('squareup.legalentities.model.FieldMetadata.Quality').values;
/**
 * SOURCE AuditLogEntry @ squareup/legalentities/model/model.proto at 719:1
 */
export const AuditLogEntry = $root.lookupType('squareup.legalentities.model.AuditLogEntry');
fixType(AuditLogEntry);
Builder.createAndAttachToType(AuditLogEntry);
/**
 * SOURCE Document @ squareup/legalentities/model/model.proto at 725:1
 */
export const Document = $root.lookupType('squareup.legalentities.model.Document');
fixType(Document);
Builder.createAndAttachToType(Document);
/**
 * SOURCE Passport @ squareup/legalentities/model/model.proto at 735:3
 */
Document.Passport = $root.lookupType('squareup.legalentities.model.Document.Passport');
fixType(Document.Passport);
Builder.createAndAttachToType(Document.Passport);
/**
 * SOURCE Gender @ squareup/legalentities/model/model.proto at 740:5
 */
Document.Passport.Gender = $root.lookupEnum('squareup.legalentities.model.Document.Passport.Gender').values;
/**
 * SOURCE DriversLicense @ squareup/legalentities/model/model.proto at 747:3
 */
Document.DriversLicense = $root.lookupType('squareup.legalentities.model.Document.DriversLicense');
fixType(Document.DriversLicense);
Builder.createAndAttachToType(Document.DriversLicense);
/**
 * SOURCE Medicare @ squareup/legalentities/model/model.proto at 753:3
 */
Document.Medicare = $root.lookupType('squareup.legalentities.model.Document.Medicare');
fixType(Document.Medicare);
Builder.createAndAttachToType(Document.Medicare);
/**
 * SOURCE CardColor @ squareup/legalentities/model/model.proto at 760:5
 */
Document.Medicare.CardColor = $root.lookupEnum('squareup.legalentities.model.Document.Medicare.CardColor').values;